module.exports = __webpack_public_path__ + "img/aini.199be3fb.gif";